
// NOTE 차트 배송관련 용어 설정
export const chartLegends = (company, props) => {
  const legendsData = [
    {
      id: "countIn",
      label:
        company === "LOGEN"
          ? "배송입고"
          : company === "LOTTE"
            ? "도착"
            : company === "KPC"
              ? "일반입고"
              : "간선하차",
      color: "#9ea3ec",
    },
    {
      id: "countOut",
      label:
        company === "LOGEN"
          ? "집하출고"
          : company === "LOTTE"
            ? "발송"
            : company === "KPC"
              ? "SLX집하"
              : "간선상차",
      color: "#ec9e9e",
    },
  ];

  return legendsData;
};
